import React from 'react';
import styled from 'styled-components';
import { useTestId } from '../../hooks/useTestId';
import { breakpoint } from '../../Themes/screensize';
import { Text } from '../../Typography/Text/Text';

export const Form = styled.div`
  ${Text} {
    margin-top: 0.5rem;
  }
`;

export const FormRow = styled.div`
  display: flex;
  align-items: stretch;
  @media (max-width: ${breakpoint.mobile}) {
    flex-wrap: wrap;
    justify-content: center;
  }
`;

export interface IFormColProps extends React.BaseHTMLAttributes<object> {
  percentWidth: number;
}

const FormColBase = styled.div<IFormColProps>`
  width: 100%;
  @media (min-width: ${breakpoint.mobileSmall}) {
    max-width: ${({ percentWidth }) => percentWidth}%;
    flex-basis: ${({ percentWidth }) => percentWidth}%;
    margin-right: 1rem;
    :last-child {
      margin-right: 0;
    }
  }
`;

export const FormCol = ({ percentWidth, children, ...rest }: IFormColProps) => {
  const { generateTestId } = useTestId(rest, 'Col');
  return (
    <FormColBase percentWidth={percentWidth} {...generateTestId()}>
      {children}
    </FormColBase>
  );
};

export const FormGroup = styled.div`
  margin-top: 2rem;
  :first-child {
    margin-top: 0;
  }
`;

export const FormGroupSeparator = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colours.separator.border};
  width: 100%;
  margin-top: 2rem;
`;
